import React from "react";

import { ReactComponent as CaretDownIcon } from "@common/assets/images/shared-icons/caret-down-icon.svg";
import { DropdownItem } from "@common/components/Dropdown/Dropdown";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { FeedbackType } from "@common/models/FeedbackType";

import * as Styled from "./FeedbackTypeDropdown.styles";

interface FeedbackTypeDropdownProps {
  feedbackType: FeedbackType;
  isOpened: boolean;
  setIsOpened: (isOpened: boolean) => void;
  changeFeedbackType: (type: FeedbackType) => void;
}

export const FeedbackTypeDropdown = ({
  feedbackType,
  isOpened,
  setIsOpened,
  changeFeedbackType,
}: FeedbackTypeDropdownProps) => {
  return (
    <Tooltip
      style={{ width: "auto" }}
      position="top"
      text="Set feedback type"
    >
      <Styled.Dropdown
        buttonElement={<CaretDownIcon />}
        label={feedbackType}
        position="left"
        isOpened={isOpened}
        setIsOpened={setIsOpened}
      >
        {Object.values(FeedbackType).map((type) => {
          return (
            <DropdownItem
              key={type}
              onClick={() => {
                setIsOpened(false);
                changeFeedbackType(type);
              }}
            >
              {type}
            </DropdownItem>
          );
        })}
      </Styled.Dropdown>
    </Tooltip>
  );
};
